<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-select v-fixZoom v-model="filterType" placeholder="请选择" style="width: 130px">
        <el-option v-for="item in filterTypeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="success" @click="getSearchData">查询</el-button>
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="person_name"
          label="老人姓名"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          label="老人性别"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getSexDesc(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="老人生日"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.birthday}}</span>
            <br>
            <span>{{getAgeDesc(scope.row.birthday)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所在床位"
          min-width="160"
          align="center">
          <template slot-scope="scope">
            <span>{{getBedDesc(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否失能"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getDisabledElderlyDesc(scope.row.disabled_elderly)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="照护等级"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getCareLevelDesc(scope.row.care_level)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="diet_level"
          label="饮食级别"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="esp_name"
          label="办理人员"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="入住时间"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="leave_time"
          label="退住时间"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="leavereason"
          label="退住原因"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          label="退住申请时间"
          width="110"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.leaveapplytime.split(' ')[0]}}</span>
            <br>
            <span>{{scope.row.leaveapplytime.split(' ')[1]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="退住审批时间"
          width="110"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.leaveaudittime.split(' ')[0]}}</span>
            <br>
            <span>{{scope.row.leaveaudittime.split(' ')[1]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100"
          align="center">
          <template slot-scope="scope">
            <div :style="{backgroundColor: scope.row.curent_state !== 3 ? 'green' : 'red', color: '#ffffff'}">
              {{getCurentStateDesc(scope.row.curent_state)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="openDetail(scope.row)">相关日志</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="detailShow" v-if="detailShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>相关日志</span>
        <div class="line-title"></div>
      </div>
      <check-in-detail :homeBedPersonObj="listObj" v-model="detailShow"></check-in-detail>
    </el-dialog>
  </div>
</template>

<script>
import {queryhomebedelderly} from '../../api/yanglaoyuan/homebed'
import checkInDetail from './components/checkInDetail'

export default {
  name: 'historyRecords',
  components: {checkInDetail},
  data () {
    return {
      entityId: 0,
      sendDate: [],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        // shortcuts: []
      },
      careLevelArr: [],
      filterTypeArr: [{id: 1, name: '入住时间'}, {id: 2, name: '退住时间'}],
      filterType: 1,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],

      detailShow: false,
      listObj: {
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.careLevelArr = this.commonType.getCareLevelArr()
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-7)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getSearchData()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },

    getSearchData () {
      this.getHomebedElderlyHistoryData()
    },

    openDetail (row) {
      this.listObj.row = row
      this.detailShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // table显示
    // 获取性别描述
    getSexDesc (sex) {
      return this.util.getSex(sex)
    },
    // 获取年龄描述 ****-**-**/age
    getAgeDesc (birthDate) {
      let result = ''
      let currentYear = new Date().getFullYear()
      let calculationYear = new Date(birthDate).getFullYear()
      let wholeTime = currentYear + birthDate.substring(4)
      let calculationAge = currentYear - calculationYear
      // 判断是否过了生日
      if (new Date().getTime() < new Date(wholeTime).getTime()) {
        calculationAge = calculationAge - 1
      }
      if (isNaN(calculationAge)) {
        result = '--'
      } else {
        result = calculationAge + '岁'
      }

      return result
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      return result
    },
    // 获取失能状态描述
    getDisabledElderlyDesc (disabledElderly) {
      let result = '否'
      if (disabledElderly === '1') {
        result = '是'
      }
      return result
    },
    // 获取护理等级描述
    getCareLevelDesc (careLevel) {
      let result = '未知'
      let careLevelObj = this.careLevelArr.find(r => r.id === careLevel.toString())
      if (careLevelObj) {
        result = careLevelObj.name
      }
      return result
    },
    // 获取居住状态描述
    getCurentStateDesc (curentState) {
      let result = ''
      if (curentState === 3) {
        result = '已退住'
      } else {
        result = '入住中'
      }
      return result
    },

    // 访问接口
    // 查询入院列表
    getHomebedElderlyHistoryData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        curent_state: [],
        elderly_name: '',
        room_name: '',
        bed_name: '',
        time_flag: this.filterType,
        start_time: this.sendDate[0] + ' 00:00:00',
        end_time: this.sendDate[1] + ' 23:59:59'
      }
      queryhomebedelderly(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.homebedperson
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/historyRecords.vue